import PropTypes from 'prop-types';
import style from '../ModalBoxWrapper.module.less';

function ModalBoxSpacer(props) {
	return <div className={style.modalSpacer + (props.fill ? ' ' + style.modalSpacerFill : '')}></div>;
}

ModalBoxSpacer.propTypes = {
	fill: PropTypes.bool,
};

ModalBoxSpacer.defaultProps = {
	fill: false,
};

export default ModalBoxSpacer;
